module.exports = __webpack_public_path__ + "img/login.a2e618b0.svg";